'use client'

import { ReactNode } from 'react'

import { View } from '@/shared/config'

import { useView } from './responsive-provider'

type Props = {
  desktop: ReactNode
  mobile: ReactNode
}

export const Responsive = ({ desktop, mobile }: Props) => {
  const { view } = useView()

  return view === View.Desktop ? desktop : mobile
}
